import { useState } from "react";
import { useSelector } from "react-redux";
import Toggle from "../../shared/v2/Toggle/Toggle";
import { useFeatureFlags } from "../../reducers/layoutReducer/selectors";

const getUseNewPage = (togglePartial, featureFlags) => {
  let value = false;
  if (togglePartial === "people/feature_toggle") value = featureFlags.newPdp;
  if (togglePartial === "listings/feature_toggle_detail") value = featureFlags.newTdp;
  return Boolean(value);
};

const getUrl = (togglePartial, newPage) => {
  let baseUrl = "";
  const urlParams = new URLSearchParams({ use_classic: newPage });
  if (togglePartial === "listings/feature_toggle_detail") {
    if (newPage) {
      baseUrl = window.location.pathname.replace("/transactions/", "/listings/");
      baseUrl = baseUrl.replace(/(timeline|tasks|notes|details|marketing|feedback|docs|financials)\/?$/, "");
      urlParams.append("tab", "tasks-tab");
    } else {
      baseUrl = window.location.pathname.replace("/listings/", "/transactions/");
    }
  }
  return `${baseUrl}?${urlParams}`;
};

const FeatureToggle = () => {
  const togglePartial = useSelector(({ layout }) => layout.togglePartial);
  const featureFlags = useFeatureFlags();
  const theme = useSelector(({ layout }) => layout.theme);
  const newPage = getUseNewPage(togglePartial, featureFlags);
  const [value, setValue] = useState(newPage);

  if (!togglePartial) return null;

  const textStyle = `tw-font-bold ${theme.name === "place-theme" ? "tw-text-white" : "tw-text-gray-50"}`;

  return (
    <Toggle
      labelPlacement="start"
      labelClassName="tw-mb-0"
      textClassName={textStyle}
      text={value ? "Modern" : "Legacy"}
      checked={value}
      onChange={() => {
        setValue(!value);
        window.location.assign(getUrl(togglePartial, value));
      }}
    />
  );
};

export default FeatureToggle;
